import axios from 'axios';

axios.defaults.withCredentials = true;

export const getLabelReports = () => axios.post('/fleet/getlabelreports')
export const getTyreLabels = (tyres,report_id) => axios.post('/fleet/getTyreLabels',{tyres : tyres, report_id: report_id})